import { ReactNode } from 'react'

export type SsoProvider = 'google' | 'apple' | 'microsoft'

export const SSO_BRAND: Record<SsoProvider, string> = {
    google: 'text-white hover:text-white bg-[#4285F4] hover:bg-[#3367d6] focus:ring-[#4285F4]/40',
    apple: 'text-white hover:text-white bg-[#0f1419] hover:bg-[#24292F] focus:ring-[#0f1419]/40',
    microsoft:
        'text-white hover:text-white bg-[#2f2f2f] hover:bg-[#1f1f1f] focus:ring-[#2f2f2f]/40',
}

export const SSO_ICON: Record<SsoProvider, ReactNode> = {
    google: (
        <svg
            className="w-4 h-4 me-1.5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="currentColor"
            viewBox="0 0 24 24">
            <path
                fillRule="evenodd"
                d="M12.037 21.998a10.313 10.313 0 0 1-7.168-3.049 9.888 9.888 0 0 1-2.868-7.118 9.947 9.947 0 0 1 3.064-6.949A10.37 10.37 0 0 1 12.212 2h.176a9.935 9.935 0 0 1 6.614 2.564L16.457 6.88a6.187 6.187 0 0 0-4.131-1.566 6.9 6.9 0 0 0-4.794 1.913 6.618 6.618 0 0 0-2.045 4.657 6.608 6.608 0 0 0 1.882 4.723 6.891 6.891 0 0 0 4.725 2.07h.143c1.41.072 2.8-.354 3.917-1.2a5.77 5.77 0 0 0 2.172-3.41l.043-.117H12.22v-3.41h9.678c.075.617.109 1.238.1 1.859-.099 5.741-4.017 9.6-9.746 9.6l-.215-.002Z"
                clipRule="evenodd"
            />
        </svg>
    ),
    apple: (
        <svg
            className="w-4 h-4 me-1.5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="currentColor"
            viewBox="0 0 24 24">
            <path d="M17.537 12.625a4.421 4.421 0 0 0 2.684 4.047 10.96 10.96 0 0 1-1.384 2.845c-.834 1.218-1.7 2.432-3.062 2.457-1.34.025-1.77-.794-3.3-.794-1.531 0-2.01.769-3.275.82-1.316.049-2.317-1.318-3.158-2.532-1.72-2.484-3.032-7.017-1.27-10.077A4.9 4.9 0 0 1 8.91 6.884c1.292-.025 2.51.869 3.3.869.789 0 2.27-1.075 3.828-.917a4.67 4.67 0 0 1 3.66 1.984 4.524 4.524 0 0 0-2.16 3.805m-2.52-7.432A4.4 4.4 0 0 0 16.06 2a4.482 4.482 0 0 0-2.945 1.516 4.185 4.185 0 0 0-1.061 3.093 3.708 3.708 0 0 0 2.967-1.416Z" />
        </svg>
    ),
    microsoft: (
        <svg
            className="w-4 h-4 me-1.5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24">
            <path fill="#f25022" d="M3 3h8.5v8.5H3z" />
            <path fill="#7fba00" d="M12.5 3H21v8.5h-8.5z" />
            <path fill="#00a4ef" d="M3 12.5h8.5V21H3z" />
            <path fill="#ffb900" d="M12.5 12.5H21V21h-8.5z" />
        </svg>
    ),
}

export const SSO_LABEL: Record<SsoProvider, string> = {
    google: 'Google',
    apple: 'Apple',
    microsoft: 'Microsoft',
}

export const SSO_BADGE: Record<SsoProvider, string> = {
    google: 'text-white bg-[#4285F4]',
    apple: 'text-white bg-[#0f1419]',
    microsoft: 'text-white bg-[#2f2f2f]',
}
